module.exports = __webpack_public_path__ + "static/media/menu_subscriptionFees_default.e85ca088.svg";